<script lang="ts">
	import { page } from '$app/stores';
	import StartOverButton from '$lib/components/StartOverButton.svelte';
	import WhatsAppSvg from '$lib/components/WhatsAppSvg.svelte';
	import { getWhatsAppUrl } from '$lib/components/whatsapp';
	import { t } from '$lib/i18n/t-store';

	function getMessageText(
		pageStatus: number,
		errorMessage?: string,
		reservationCode?: string,
		rid?: string
	) {
		let message = $t(`pageError.whatsappMsg.firstLine`, { values: { errorCode: pageStatus } });

		if (errorMessage) {
			message += ' ' + $t(`pageError.whatsappMsg.errorDetails`, { values: { errorMessage } });
		}

		if (rid) {
			message = message.slice(0, -1) + ` (rid ${rid}).`;
		}

		if (reservationCode) {
			message += ' ' + $t(`pageError.whatsappMsg.reservationCode`, { values: { reservationCode } });
		}

		return message;
	}

	$: messageText = getMessageText(
		$page.status,
		$page.error?.message,
		$page.error?.reservationCode,
		$page.error?.rid
	);
</script>

<div class="centered">
	<h1>{@html $t(`pageError.mainText`)}</h1>

	{#if $page.error}
		<pre>{$page.error.message}</pre>
	{/if}

	<a href={getWhatsAppUrl({ text: messageText })} target="_blank" class="btn">
		{@html $t(`pageError.contactUsText`)}
	</a>
</div>

<a
	href={getWhatsAppUrl({ text: messageText })}
	target="_blank"
	title={$t(`pageError.contactUsButtonAlt`)}
	class="btn whatsapp-contact"
>
	<WhatsAppSvg width="100%" height="100%" />
</a>

<style lang="scss">
	.centered {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.btn {
		padding: 0.3rem 0.5rem;
		border-radius: 0.3rem;
	}

	:global(.start-over) {
		// background: unset;
		// position: fixed;
		// // width: 2.5rem;
		// height: 2rem;
		// top: 1rem;
		// left: 1rem;
		z-index: 1000;
	}

	.whatsapp-contact {
		background: unset;
		position: fixed;
		width: 2.5rem;
		height: 2.5rem;
		bottom: 1rem;
		right: 1rem;
		z-index: 1000;
	}
</style>
